import { Button, Spin } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Form } from "react-bootstrap";
import { Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import CustomTextArea from "../../../CustomControls/CustomTextArea";
import {
  delete_Record,
  errorMessage,
  warningMessage,
} from "../CommonFunctions";
import {
  POST_ChatBoxEmployeeMessageDelete,
  POST_ChatBoxEmployeeMessageInsert,
  POST_GetSpecificEmployeeMessageList,
} from "../../../helpers/url_helper";
import { post, postFormData } from "../../../helpers/api_helper";
import { useChatContext } from "../../../../context/ChatContext";
import moment from "moment";
import { useDispatch } from "react-redux";
import InfiniteScroll from "react-infinite-scroll-component";
import { SVGICON } from "../../../constant/theme";
import { v4 as uuidv4 } from "uuid";

const ChatMsgBox = ({
  EmpID,
  avatar1,
  avatar2,
  openMsg,
  EmaployeeNameForChat,
  offMsg,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [toggle, setToggle] = useState(false);
  const { chat, deleteMessageBatchID } = useChatContext();

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

  const formsList = AuthUser?.Permissions?.FormList;
  const chatContainerRef = useRef(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [currentSizePerPage, setCurrentSizePerPage] = useState(50);
  const [recordCount, setRecordCount] = useState(0);

  const validationSchema = Yup.object().shape({});

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      SpecificEmployeeMsgList: [],
      EmployeeIDEncrypt: EmpID,
      btnSubmitType: "",
      TextMessage: "",
      ChatFilekey: "",
      ChatBoxFile: "",
      ChatFileName: "",
      ChatSendFile: "",
    },
    validateOnBlur: false,
  });

  const {
    setFieldValue,
    values: {
      SpecificEmployeeMsgList,
      EmployeeIDEncrypt,
      TextMessage,
      ChatFilekey,
      ChatBoxFile,
      ChatFileName,
      ChatSendFile,
    },
  } = formik;

  const handleValidSubmit = (values) => {};

  useEffect(() => {
    scrollToBottom();
    if (EmpID) {
      getSpecificEmployeeDetails(currentPage, currentSizePerPage);
    }
  }, [openMsg]);

  const fnCallback = () => {
    getSpecificEmployeeDetails(currentPage, currentSizePerPage);
  };

  const getSetTextMsg = () => {
    if (TextMessage !== "" || ChatFileName !== "") {
      const result = getDateTimeInfoByDate();
      let guid = uuidv4(); //BatchID created

      let currentDate = new Date();
      const formattedDate = `${currentDate.getDate()}-${currentDate.toLocaleString(
        "default",
        { month: "short" }
      )}-${currentDate.getFullYear()} ${currentDate.toLocaleTimeString(
        "en-US"
      )}`;

      // setIsLoading(true);

      let formData = new FormData();
      formData.append(
        "SenderIDEncrypt",
        AuthUser?.ReferenceIDEncrypt ? AuthUser?.ReferenceIDEncrypt : "0"
      );
      formData.append("ReceiverIDs", EmpID);
      formData.append("ChatMessage", TextMessage);
      //formData.append("ChatDateTime", formattedDate);
      formData.append(
        "ChatDateTime",
        moment(formattedDate).format("DD-MMM-yyyy hh:mm:ss A")
      );
      formData.append("ChatBoxFile", ChatBoxFile);
      formData.append("ChatBoxFilePath", "");
      formData.append("ChatFileName", ChatFileName);
      formData.append("BatchID", guid);

      formData.append("CompanyIDEncrypted", AuthUser?.CompanyIDEncrypt);
      formData.append("BranchIDEncrypted", AuthUser?.BranchIDEncrypt);
      formData.append(
        "CreatedByEncrypt",
        AuthUser?.ReferenceIDEncrypt ? AuthUser?.ReferenceIDEncrypt : "0"
      );
      formData.append("IsAll", false);

      postFormData(POST_ChatBoxEmployeeMessageInsert, formData)
        .then((response) => {
          //setIsLoading(true);
          if (response?.IsSuccess) {
            formik.setFieldValue("SpecificEmployeeMsgList", [
              ...SpecificEmployeeMsgList,
              {
                ChatBoxIDEncrypt: "",
                SenderIDEncrypt: "",
                ReceiverIDEncrypt: "",
                ChatMessage: TextMessage,
                ChatFilePath: "",
                ChatFileName: ChatFileName,
                ChatSendFile: ChatSendFile,
                ChatDate: result,
                ChatDateTime: "",
                ChatDateWeek: "",
                IsRead: false,
                ReadDate: "",
                BatchID: guid,
                SenderName: "",
                SenderEmployeePhoto: "",
                ReceiverName: "",
                ReceiverEmployeePhoto: "",
                MessageType: ChatFileName ? 3 : 2,
              },
            ]);
          } else {
            errorMessage(response?.Message);
          }
          //setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          //setIsLoading(false);
        });
    } else {
      errorMessage("Please enter Message or file");
      return false;
    }

    formik.setFieldValue("TextMessage", "");
    formik.setFieldValue("ChatBoxFile", "");
    formik.setFieldValue("ChatFileName", "");
    formik.setFieldValue("ChatSendFile", "");

    scrollToBottom();
  };

  const uploadFileChange = (e) => {
    if (e.target.files[0]) {
      const file = e.target.files[0];

      //  // Maximum file size in bytes (adjust as needed)
      const maxSize = 20 * 1024 * 1024; // 20 MB

      if (file.size > maxSize) {
        warningMessage("File size exceeds the limit (20 MB)");
        formik.setFieldValue(
          "ChatFilekey",
          Math.random().toString(9).substring(2, 9)
        );
        formik.setFieldValue("EmployeeIDEncrypt", "");
        formik.setFieldValue("TextMessage", "");

        formik.setFieldValue("ChatBoxFile", "");
        formik.setFieldValue("ChatFileName", "");
        formik.setFieldValue("ChatSendFile", "");

        return;
      }

      const fileName = file.name;
      const fileExtension = fileName.split(".").pop().toLowerCase(); // Extract file extension
      let fileExtensionName = fileExtension;

      if (
        fileExtensionName === "png" ||
        fileExtensionName === "gif" ||
        fileExtensionName === "jpeg" ||
        fileExtensionName === "jpg"
      ) {
        fileExtensionName = "image";
      } else if (fileExtensionName === "xls" || fileExtensionName === "xlsx") {
        fileExtensionName = "excel";
      } else if (fileExtension === "pdf") {
        fileExtensionName = "pdf";
      } else if (fileExtension === "txt") {
        fileExtensionName = "text";
      } else if (
        fileExtensionName === "bmp" ||
        fileExtensionName === "ppt" ||
        fileExtensionName === "zip" ||
        fileExtensionName === "rar"
      ) {
        fileExtensionName = fileExtensionName;
      } else if (fileExtensionName === "doc" || fileExtensionName === "docx") {
        fileExtensionName = "word";
      } else {
        // Handle other file types here
        fileExtensionName = "unknown";
      }

      const fileType = file.type;
      const validFileTypes = [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel",
        "image/png", // Image MIME types
        "image/gif",
        "image/jpeg",
        "image/jpg",
        "application/pdf", // PDF MIME type
        "text/plain", // Text file MIME type
        "image/bmp", // BMP MIME type
        "application/vnd.ms-powerpoint", // PPT MIME type
        "application/zip", // ZIP MIME type
        "application/x-rar-compressed", // RAR MIME type
        "application/msword", // DOC MIME type
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // DOCX MIME type
        "audio/mpeg", // MP3
        "audio/wav", // WAV
        "audio/x-ms-wma", // WMA
        "video/mp4", // MP4
        "video/quicktime", // MOV
        "video/x-msvideo", // AVI
        "video/x-matroska", // MKV
      ]; // MIME types for Excel files

      if (!validFileTypes.includes(fileType)) {
        warningMessage("Please select a valid file");
        formik.setFieldValue(
          "ChatFilekey",
          Math.random().toString(9).substring(2, 9)
        );
        formik.setFieldValue("EmployeeIDEncrypt", "");
        formik.setFieldValue("TextMessage", "");
        return;
      } else {
        formik.setFieldValue("ChatBoxFile", file);
        formik.setFieldValue("ChatFileName", file?.name);
        formik.setFieldValue("ChatSendFile", URL.createObjectURL(file));

        formik.setFieldValue(
          "ChatFilekey",
          Math.random().toString(9).substring(2, 9)
        );
      }
    }

    scrollToBottom();
  };

  useEffect(() => {
    if (chat) {
      scrollToBottom();
      if (
        chat?.filter(
          (x) => x?.ReceiverIDEncrypt == AuthUser?.ReferenceIDEncrypt
        )?.length > 0
      ) {
        chat
          ?.filter((x) => x?.ReceiverIDEncrypt == AuthUser?.ReferenceIDEncrypt)
          ?.map((item) => {
            formik.setFieldValue("SpecificEmployeeMsgList", [
              ...SpecificEmployeeMsgList,
              { ...item, MessageType: item?.MessageType == 2 ? 1 : 4 },
            ]);
          });
      }

      scrollToBottom();
    }
  }, [chat]);

  useEffect(() => {
    if (deleteMessageBatchID) {
      scrollToBottom();

      formik.setFieldValue(
        "SpecificEmployeeMsgList",
        SpecificEmployeeMsgList?.filter(
          (x) =>
            x?.BatchID != deleteMessageBatchID &&
            x?.ReceiverIDEncrypt == AuthUser?.ReferenceIDEncrypt
        )
      );
      getSpecificEmployeeDetails(currentPage, currentSizePerPage);
      scrollToBottom();
    }
  }, [deleteMessageBatchID]);

  useEffect(() => {
    // Scroll down when component mounts or when props.messages change
    scrollToBottom();
  }, [TextMessage]);

  const scrollToBottom = () => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    }
  };

  const getSpecificEmployeeDetails = (page = 1, sizePerPage = 50) => {
    setIsLoading(true);
    post(POST_GetSpecificEmployeeMessageList, {
      ReceiverIDEncrypted: AuthUser?.ReferenceIDEncrypt,
      SenderIDEncrypted: EmpID,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      CurrentPage: page,
      PageSize: sizePerPage,
      Search: "",
      Sorting: "",
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setFieldValue("SpecificEmployeeMsgList", response?.List);
          setRecordCount(response?.TotalRecordCount);
          scrollToBottom();
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
    scrollToBottom();
  };

  const dataLoadOnScroll = async () => {
    setCurrentPage(currentPage + 1);

    post(POST_GetSpecificEmployeeMessageList, {
      ReceiverIDEncrypted: AuthUser?.ReferenceIDEncrypt,
      SenderIDEncrypted: EmpID,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      CurrentPage: currentPage + 1,
      PageSize: currentSizePerPage,
      Search: "",
      Sorting: "",
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setFieldValue("SpecificEmployeeMsgList", [
            ...response?.List,
            ...SpecificEmployeeMsgList,
          ]);
          setRecordCount(response?.TotalRecordCount);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  function getDateTimeInfoByDate() {
    // Create Date objects for comparison
    const currentDate = new Date();
    const inputDate = new Date();

    // Function to format time in hh:mm:ss format
    const formatTime = (inputDate) => {
      const timeString = inputDate.toLocaleTimeString();
      const formattedTime = timeString.replace(/:\d+ /, " "); // Remove seconds
      return formattedTime.padStart(8, "0");
    };

    if (inputDate.toDateString() === currentDate.toDateString()) {
      return "Today | " + formatTime(inputDate);
    }
  }

  const setRemoveFile = () => {
    formik.setFieldValue("TextMessage", "");
    formik.setFieldValue("ChatBoxFile", "");
    formik.setFieldValue("ChatFileName", "");
    formik.setFieldValue("ChatSendFile", "");
  };

  return (
    <Spin
      size="large"
      spinning={isLoading}
      tip={"Loading..."}
      style={{ position: "fixed" }}
    >
      <div
        className={`card chat dlab-chat-history-box ${openMsg ? "" : "d-none"}`}
      >
        <div className="card-header chat-list-header text-center">
          <Link
            to={"#"}
            className="dlab-chat-history-back"
            onClick={() => offMsg()}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              width="18px"
              height="18px"
              viewBox="0 0 24 24"
              version="1.1"
            >
              <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <polygon points="0 0 24 0 24 24 0 24" />
                <rect
                  fill="#000000"
                  opacity="0.3"
                  transform="translate(15.000000, 12.000000) scale(-1, 1) rotate(-90.000000) translate(-15.000000, -12.000000) "
                  x="14"
                  y="7"
                  width="2"
                  height="10"
                  rx="1"
                />
                <path
                  d="M3.7071045,15.7071045 C3.3165802,16.0976288 2.68341522,16.0976288 2.29289093,15.7071045 C1.90236664,15.3165802 1.90236664,14.6834152 2.29289093,14.2928909 L8.29289093,8.29289093 C8.67146987,7.914312 9.28105631,7.90106637 9.67572234,8.26284357 L15.6757223,13.7628436 C16.0828413,14.136036 16.1103443,14.7686034 15.7371519,15.1757223 C15.3639594,15.5828413 14.7313921,15.6103443 14.3242731,15.2371519 L9.03007346,10.3841355 L3.7071045,15.7071045 Z"
                  fill="#000000"
                  fillRule="nonzero"
                  transform="translate(9.000001, 11.999997) scale(-1, -1) rotate(90.000000) translate(-9.000001, -11.999997) "
                />
              </g>
            </svg>
          </Link>
          <div>
            <h6 className="mb-1">Chat with {EmaployeeNameForChat}</h6>
            {/* <p className="mb-0 text-success">Online</p> */}
          </div>

          <div className="dropdown"></div>
        </div>
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <div
              className="card-body msg_card_body_chatmsgbox dz-scroll"
              id="DZ_W_Contacts_Body7"
              ref={chatContainerRef}
              style={{
                overflow: "auto",
                display: "flex",
                flexDirection: "column-reverse",
              }}
              key={1}
            >
              <InfiniteScroll
                dataLength={SpecificEmployeeMsgList.length}
                next={dataLoadOnScroll}
                hasMore={true}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  perspective: "1px",
                }}
                inverse={true} //
                scrollableTarget="DZ_W_Contacts_Body7"
              >
                {SpecificEmployeeMsgList?.length > 0
                  ? SpecificEmployeeMsgList?.map((item, indx) => (
                      <>
                        {item?.MessageType == 1 ? (
                          <div
                            className="d-flex justify-content-start mb-4"
                            key={indx}
                          >
                            <div className="img_cont_msg">
                              <img
                                src={item?.SenderEmployeePhoto}
                                className="rounded-circle user_img_msg"
                                alt=""
                              />
                            </div>

                            <div className="msg_cotainer">
                              <div
                                className="d-flex justify-content-start"
                                style={{ color: "#ffcb52" }}
                              >
                                {item?.SenderName}
                              </div>
                              <div
                                style={{
                                  textAlign: "left",
                                  whiteSpace: "pre-wrap",
                                }}
                              >
                                {item?.ChatMessage}
                              </div>
                              <span className="msg_time">{item?.ChatDate}</span>
                            </div>
                          </div>
                        ) : item?.MessageType == 3 ? (
                          <div
                            className="d-flex justify-content-end mb-4"
                            key={indx}
                          >
                            {/* <div className="msg_cotainer_send"> */}
                            <Link
                              to="#"
                              className="msg_cotainer_send"
                              title="View File"
                              style={{ maxWidth: "90%" }}
                              onClick={() => {
                                window.open(
                                  item.ChatFilePath
                                    ? item.ChatFilePath
                                    : item.ChatSendFile
                                );
                              }}
                            >
                              <i
                                className="fa fa-file "
                                aria-hidden="true"
                                style={{
                                  fontSize: "xxx-large",
                                }}
                              ></i>

                              <br />
                              <span className="msg_time_sendfilebox">
                                {item?.ChatFileName}
                              </span>
                              <div
                                style={{
                                  textAlign: "left",
                                  whiteSpace: "pre-wrap",
                                }}
                              >
                                {item?.ChatMessage}
                              </div>
                              <span className="msg_time_send">
                                {item?.ChatDate}
                              </span>
                            </Link>
                            {/* </div> */}
                            <div className="img_cont_msg">
                              <img
                                src={
                                  item?.SenderEmployeePhoto == ""
                                    ? AuthUser?.Photo
                                    : item?.SenderEmployeePhoto
                                }
                                className="rounded-circle user_img_msg"
                                alt=""
                              />
                              <div
                                className="dropdown"
                                style={{ textAlign: "center" }}
                              >
                                <Link
                                  to={"#"}
                                  data-toggle="dropdown"
                                  aria-expanded="false"
                                  title="Delete Message"
                                  onClick={() => {
                                    delete_Record(
                                      POST_ChatBoxEmployeeMessageDelete,
                                      {
                                        BatchID: item?.BatchID,
                                        EmployeeIDEncrypted: EmployeeIDEncrypt,
                                        ModifiedByEncrypt:
                                          AuthUser?.ReferenceIDEncrypt
                                            ? AuthUser?.ReferenceIDEncrypt
                                            : "0",
                                      },
                                      setIsLoading,
                                      fnCallback,
                                      "Message"
                                    );
                                  }}
                                >
                                  {SVGICON.DeleteDanger}
                                </Link>
                              </div>
                            </div>
                          </div>
                        ) : item?.MessageType == 2 ? (
                          <div
                            className="d-flex justify-content-end mb-4"
                            key={indx}
                          >
                            <div className="msg_cotainer_send">
                              <div
                                style={{
                                  textAlign: "left",
                                  whiteSpace: "pre-wrap",
                                }}
                              >
                                {item?.ChatMessage}
                              </div>
                              <span className="msg_time_send">
                                {item?.ChatDate}
                              </span>
                            </div>
                            <div className="img_cont_msg">
                              <img
                                src={
                                  item?.SenderEmployeePhoto == ""
                                    ? AuthUser?.Photo
                                    : item?.SenderEmployeePhoto
                                }
                                className="rounded-circle user_img_msg"
                                alt=""
                              />{" "}
                              <div
                                className="dropdown"
                                style={{ textAlign: "center" }}
                              >
                                <Link
                                  to={"#"}
                                  data-toggle="dropdown"
                                  aria-expanded="false"
                                  title="Delete Message"
                                  onClick={() => {
                                    delete_Record(
                                      POST_ChatBoxEmployeeMessageDelete,
                                      {
                                        BatchID: item?.BatchID,
                                        EmployeeIDEncrypted: EmployeeIDEncrypt,
                                        ModifiedByEncrypt:
                                          AuthUser?.ReferenceIDEncrypt
                                            ? AuthUser?.ReferenceIDEncrypt
                                            : "0",
                                      },
                                      setIsLoading,
                                      fnCallback,
                                      "Message"
                                    );
                                  }}
                                >
                                  {SVGICON.DeleteDanger}
                                </Link>
                              </div>
                            </div>
                          </div>
                        ) : item?.MessageType == 4 ? (
                          <div
                            className="d-flex justify-content-start mb-4"
                            key={indx}
                          >
                            <div className="img_cont_msg">
                              <img
                                src={item?.SenderEmployeePhoto}
                                className="rounded-circle user_img_msg"
                                alt=""
                              />
                            </div>

                            <div className="msg_cotainer">
                              <div
                                className="d-flex justify-content-start"
                                style={{ color: "#ffcb52" }}
                              >
                                {item?.SenderName}
                              </div>
                              <Link
                                to="#"
                                className=""
                                title="View File"
                                style={{ maxWidth: "90%" }}
                                onClick={() => {
                                  window.open(
                                    item.ChatFilePath
                                      ? item.ChatFilePath
                                      : item.ChatSendFile
                                  );
                                }}
                              >
                                <i
                                  className="fa fa-file "
                                  aria-hidden="true"
                                  style={{
                                    fontSize: "xxx-large",
                                  }}
                                ></i>
                                <br />
                                <span className="msg_time_sendfilebox">
                                  {item?.ChatFileName}
                                </span>
                                <div
                                  style={{
                                    textAlign: "left",
                                    whiteSpace: "pre-wrap",
                                  }}
                                >
                                  {item?.ChatMessage}
                                </div>
                                <span className="msg_time">
                                  {item?.ChatDate}
                                </span>
                              </Link>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                      </>
                    ))
                  : ""}
              </InfiniteScroll>
            </div>
            <div
              className="card-footer type_msg"
              style={{
                position: "sticky",
                bottom: "0px",
                //backgroundColor: "#fff",
              }}
            >
              {ChatFileName ? (
                <>
                  <span>{ChatFileName}</span>
                  <Button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setRemoveFile()}
                  ></Button>
                </>
              ) : (
                ""
              )}
              <div className="input-group">
                <div style={{ width: "90%", paddingRight: 10 }}>
                  <Field
                    name="TextMessage"
                    placeholder={"Type Your Message..."}
                    component={CustomTextArea}
                    rows={4}
                    noMarginBottom={true}
                  />
                </div>
                <div className="input-group-append " style={{ width: "10%" }}>
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm"
                    onClick={() => {
                      getSetTextMsg();
                    }}
                  >
                    <i className="fa fa-location-arrow"></i>
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={() =>
                      document.getElementById("chatFileUploadbox").click()
                    }
                  >
                    <i className="fa fa-paperclip" aria-hidden="true"></i>
                  </button>
                  <input
                    type="file"
                    id="chatFileUploadbox"
                    className="d-none" // Use CSS to hide the file input visually
                    onChange={uploadFileChange}
                    key={ChatFilekey || ""}
                  />
                </div>
              </div>
            </div>
          </Form>
        </FormikProvider>
      </div>
    </Spin>
  );
};

export default ChatMsgBox;
